export default function PreLoader({ content }) {
    return (
        <div className="blog-state-wrapper">
            <div className="container">
                <div className="blog-state-card">
                    <p>{ content || "Loading..."}</p>
                </div>
            </div>
        </div>
    );
}